import React, { useState, useEffect } from "react";
import Container from "./container";
import { Link } from "gatsby";
import * as styles from "../styles/components/announcement-bar.module.css";
import { cn } from "../lib/helpers";
import PortableText from "./portableText";
import Icon from "./icon";

const AnnouncementBar = ({ button, _rawContent, id }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const idLocal = localStorage.getItem("announcementId");
    if (idLocal === id) {
      setIsVisible(false);
    }

    // Event listener for closing the bar when any link is clicked
    const handleClick = (event) => {
      const target = event.target;
      if (target.tagName === 'A' || target.closest('a')) {
        handleClose();
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [id]);

  const handleClose = () => {
    localStorage.setItem("announcementId", id);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={cn(styles.root, "color-palette-bg")}>
      <Container announcementContainer>
        <div className={styles.wrapper}>
          {_rawContent && (
            <div className={cn("entry-content", styles.content)}>
              <PortableText blocks={_rawContent} />
            </div>
          )}
          {button ? (
            button?.blank ? (
              <a
                href={button.url}
                className={cn(
                  "btn secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke",
                  styles.button
                )}
                target="_blank"
                rel="noreferrer"
              >
                {button.text}
                <Icon symbol="arrow-right" />
              </a>
            ) : (
              <Link
                to={button.url}
                className={cn(
                  "btn secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke",
                  styles.button
                )}
              >
                {button.text}
                <Icon symbol="arrow-right" />
              </Link>
            )
          ) : null}
        </div>
      </Container>
      <button onClick={handleClose} className={styles.closeButton}>
        <Icon symbol="close" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
